import { render, staticRenderFns } from "./ProductSearchBox.vue?vue&type=template&id=df34323c&scoped=true"
import script from "./ProductSearchBox.vue?vue&type=script&lang=js"
export * from "./ProductSearchBox.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchBox.vue?vue&type=style&index=0&id=df34323c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34323c",
  null
  
)

export default component.exports